export const AuthErrorMessages = {
  'Firebase: Error (auth/invalid-credential).': 'Invalid credential',
  'Firebase: Error (auth/email-already-in-use).': 'Email already in use.',
  'auth/email-already-exists': 'Email already in use.',
  'auth/invalid-email': 'Invalid email address.',
  'auth/operation-not-allowed': 'This operation is not allowed.',
  'auth/weak-password': 'Weak password.',
  'auth/wrong-password': 'Incorrect password.',
  'auth/invalid-password': 'Invalid password, minimum 6 characters.',
  'auth/invalid-uid': 'Invalid user.',
  'auth/user-disabled': 'Your user account has been blocked.',
  'auth/user-not-found': 'User not found, please check your email.',
  'auth/network-request-failed': 'Connection error.',
  'auth/email-already-in-use': 'The email is already in use.',
  'auth/invalid-verification-code': 'Invalid verification code.',
  'auth/invalid-verification-id': 'Invalid verification ID.',
  'auth/missing-verification-code': 'Verification code is missing.',
  'auth/missing-verification-id': 'Verification ID is missing.',
  'auth/phone-number-already-exists': 'The phone number already exists.',
  'auth/invalid-phone-number': 'Invalid phone number.',
  'auth/missing-phone-number': 'Phone number is missing.',
  'auth/quota-exceeded': 'Quota exceeded.',
  'auth/captcha-check-failed': 'Captcha verification failed.',
  'auth/invalid-app-credential': 'Invalid application credentials.',
  'auth/invalid-app-id': 'Invalid application ID.',
  'auth/recent-login-required': 'Recent login required.',
  'functions/not-found': 'An unexpected error occurred, please try again. If the problem persists, contact support.'
}
